/**
 * Product Tabs — vanilla JS, no theme dependency.
 * Supports multiple instances of the section on the same page
 * and re-initializes on Shopify theme editor block/section events.
 */
(function () {
  'use strict';

  function initProductTabs(root) {
    if (!root || root.dataset.ptInitialized === 'true') return;
    root.dataset.ptInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-tab-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));

    if (!triggers.length || !panels.length) return;

    function activate(index) {
      triggers.forEach(function (trigger) {
        var isActive = trigger.dataset.index === String(index);
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.index === String(index);
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activate(trigger.dataset.index);
      });

      trigger.addEventListener('keydown', function (event) {
        var currentIndex = triggers.indexOf(trigger);
        var nextIndex = null;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % triggers.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          triggers[nextIndex].focus();
          activate(triggers[nextIndex].dataset.index);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-tabs]').forEach(initProductTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-tabs]');
    if (root) {
      root.dataset.ptInitialized = 'false';
      initProductTabs(root);
    }
  });
})();
